// extracted by mini-css-extract-plugin
export var homepageTabUl = "TabItem-module--homepage-tab-ul--0ff09";
export var tabItemButton = "TabItem-module--tab-item-button--54d89";
export var tabItemButtonSelected = "TabItem-module--tab-item-button-selected--fed2c";
export var tabItemContainer = "TabItem-module--tab-item-container--d63b5";
export var tabItemSelected = "TabItem-module--tab-item-selected--392b9";